module.exports = __webpack_public_path__ + "img/ipad_cn.65afcf4.jpg";